function wrapperSelector(mainElement = null) {
  
  // If we don't pass a main element, we try to find it
  if(mainElement == null){
    mainElement = document.querySelector("main#MainContent");
  }
  if (!mainElement) {
    console.warn("Main content element not found");
    return null;
  }
  let wrappers = [];
  
    document.querySelectorAll(".card").forEach((wrapper) => {
      if(wrapper.querySelector(".add-to-cart")){
        wrappers.push(wrapper);
      }
    });
  
  if (mainElement.classList.contains("page-product")) {
    // Treat it as an array so that the forEach loop works
    wrappers.push(document.querySelector(".product__info-wrapper"));
  }
  return wrappers;
}

function variableItemSelector(wrappers) {
  wrappers.forEach((card) => {
    const button = card.querySelector(".add-to-cart");
    const variants = JSON.parse(button.getAttribute("data-variants"));
    const variable_prices = card.querySelectorAll(".variable-price__item");
    const input = card.querySelector(".input input");
    const sizes = Array.from(card.querySelectorAll(".size")).map((size) => size.getAttribute("data-size"));

    variable_prices.forEach((item) => {
      item.addEventListener("click", function () {
        variable_prices.forEach((item) => {
          item.classList.remove("-selected");
        });
        item.classList.add("-selected");
        if (item.getAttribute("data-size") === "1") {
          button.setAttribute("data-variant", variants[0]);
          input.value = 1;
        } else if (+item.getAttribute("data-size") >= sizes[2]) {
          button.setAttribute("data-variant", variants[2]);
          input.value = sizes[2];
        } else {
          button.setAttribute("data-variant", variants[1]);
          input.value = sizes[1];
        }
        button.setAttribute("data-qty", item.getAttribute("data-size"));
      });
    });
  });
}

function updateVariant(value, sizes, variants, variable_prices) {
  variable_prices.forEach((item) => {
    item.classList.remove("-selected");
  });
  if (value >= sizes[1] && value < sizes[2]) {
    variable_prices[1].classList.add("-selected");
    return variants[1];
  } else if (value >= sizes[2]) {
    variable_prices[2].classList.add("-selected");
    return variants[2];
  } else {
    variable_prices[0].classList.add("-selected");
    return variants[0];
  }
}

function qtySelector(selectors) {
  selectors.forEach(function (selector) {
    let card;
    const isMainProduct = document.querySelector(".section-main-product");
    if (isMainProduct) {
      card = selector.closest(".product__info-container");
    }else {
      card = selector.closest(".card__information");
    }
      
    
    const addButton = selector.querySelector(".plus");
    const minusButton = selector.querySelector(".minus");
    const input = selector.querySelector(".input input");
    const addToCartBtn = card.querySelector(".add-to-cart");
    const variants = JSON.parse(addToCartBtn.getAttribute("data-variants"));
    const sizes = Array.from(card.querySelectorAll(".size")).map((size) => size.getAttribute("data-size"));
    const variable_prices = card.querySelectorAll(".variable-price__item");

    if (input.value == 1) {
      minusButton.setAttribute("disabled", "disabled");
      minusButton.classList.toggle("disabled");
    }

    addButton.addEventListener("click", function () {
      if (minusButton.hasAttribute("disabled")) {
        minusButton.removeAttribute("disabled");
        minusButton.classList.toggle("disabled");
      }
      const value = parseInt(input.value);
      const newValue = value + 1;

      input.value = newValue;
      addToCartBtn.setAttribute("data-qty", newValue);

      addToCartBtn.setAttribute("data-variant", updateVariant(newValue, sizes, variants, variable_prices));
    });

    minusButton.addEventListener("click", function () {
      const value = parseInt(input.value);
      let newValue = value;
      if (value > 1) {
        newValue = value - 1;
        input.value = newValue;
        addToCartBtn.setAttribute("data-qty", newValue);
      }

      addToCartBtn.setAttribute("data-variant", updateVariant(newValue, sizes, variants, variable_prices));
    });

    input.addEventListener("change", function () {
      const value = parseInt(input.value);

      if (value == 1) {
        minusButton.setAttribute("disabled", "disabled");
        minusButton.classList.toggle("disabled");
      } else {
        minusButton.removeAttribute("disabled");
        minusButton.classList.remove("disabled");
      }

      addToCartBtn.setAttribute("data-qty", value);

      addToCartBtn.setAttribute("data-variant", updateVariant(value, sizes, variants, variable_prices));
    });
  });
}

// Cambio de colores

const asignCardColor = (wrappers) => {
  wrappers.forEach((wrapper) => {
    wrapper.querySelectorAll(".card-color").forEach((element) => {
      element.addEventListener("click", function () {
        let parent, productImage, colorName;
        if(wrapper.classList.contains("product__info-wrapper")){
          parent = wrapper.closest(".product");
          productImage = parent.querySelector(".product__media-wrapper img");
          colorName = parent.querySelector(".product__color");
        }else if(wrapper.classList.contains('card')){
          parent = this.closest(".card-wrapper");
          productImage = parent.querySelector(".card__media img");
          colorName = parent.querySelector(".card-information__color");
        }
        // Border color on/off
        document.querySelectorAll(".card-color").forEach((el) => {
          el.classList.remove("-selected");
        });
        this.classList.add("-selected");

        // Change image
        const imgSrc = this.dataset.img;
        if (!document.getElementById("main-product-page")) {
          productImage.srcset = imgSrc;
          productImage.src = imgSrc;

          // If modal, change the modal src as well
          const modalContainer = document.querySelector(".product-media-modal__content");
          if(modalContainer && modalContainer.querySelector('img')){
            modalContainer.querySelector('img').src = imgSrc;
            modalContainer.querySelector('img').srcset = imgSrc;
          }
        }

        // Add variant name
        const name = this.dataset.name;
        
        colorName.textContent = name;

        // Logic for add to cart button
        const variant1 = this.dataset.variant1;
        const variants = JSON.parse(this.dataset.variants);
        if (document.querySelector(".add-to-cart")) {
          const buttonCart = parent.querySelector(".add-to-cart");
          buttonCart.dataset.variant = variant1;
          buttonCart.dataset.variants = `[${variants[0]},${variants[1]},${variants[2]}]`;
        }
      });
    });
  });
};

function initVideoPreview(wrappers) {
  wrappers.forEach((wrapper) => {
    const toggle = wrapper.querySelector(".video-toggle");
    const videoPreview = wrapper.querySelector(".video-preview");
    if (toggle && videoPreview) {
      toggle.addEventListener("click", function () {
        // console.log('toggle clicked')
        if (videoPreview.classList.contains("-hidden")) {
          videoPreview.classList.remove("-hidden");
        } else {
          videoPreview.classList.add("-hidden");
        }
      });
    }
  });
}

const initProductVideo = () => {
  if (document.querySelector('.product__media-list .video-toggle')) {
    document.querySelector('.product__media-list .video-toggle').addEventListener('click', function () {
      const video = document.querySelector('.media-video');
      const videoSvg = document.querySelector('.video-icon');
      const imageSvg = document.querySelector('.image-icon');
      const modalOpeners = document.querySelectorAll('.product__media-toggle');

      modalOpeners.forEach((opener) => {
        opener.classList.toggle('-hidden');
      });
      if (video.classList.contains('-hidden')) {
        video.classList.remove('-hidden');
        video.style.display = 'block';
      } else {
        video.classList.add('-hidden');
        video.style.display = 'none';
      }
      videoSvg.classList.toggle('-hidden');
      imageSvg.classList.toggle('-hidden');
    });
  }
}

function cardFormResize(){
  const cardForms = document.querySelectorAll(".card__form");
  cardForms.forEach((form) => {
    // console.log(form.clientWidth);

    if(form.clientWidth < 300){
      form.classList.add("card__form--small");
    }else{
      if(form.classList.contains("card__form--small")){
        form.classList.remove("card__form--small");
      }
    }
  })
}

const zoomImage = () => {
  const container = document.querySelector('.product__media');
  if (!container) return;
  const image = container.querySelector('img'); // safer, relative to container
  const zoom = 1.5;

  if (!container || !image) return;

  container.addEventListener('mouseenter', () => {
    image.style.transition = 'transform 0.2s ease';
    image.style.transform = `scale(${zoom})`;
  });

  container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();

    const posX = ((e.clientX - rect.left) / rect.width) * 100;
    const posY = ((e.clientY - rect.top) / rect.height) * 100;

    image.style.transformOrigin = `${posX}% ${posY}%`;
  });

  container.addEventListener('mouseleave', () => {
    image.style.transition = 'transform 0.2s ease';
    image.style.transform = 'scale(1)';
    image.style.transformOrigin = 'center center';
  });
};

document.addEventListener("DOMContentLoaded", function () {
  // Init functions
  const wrappers = wrapperSelector();
  variableItemSelector(wrappers);

  if (document.querySelector(".section-main-product")) {
    // En main product solo tomamos el primer qtySelector
    const selectors = [document.querySelector(".quantity__selector")];
    qtySelector(selectors);
  }else{ 
    const selectors = document.querySelectorAll(".quantity__selector");
    qtySelector(selectors);
  }
  asignCardColor(wrappers);
  initVideoPreview(wrappers);
  cardFormResize();
  initProductVideo();
  zoomImage();
});

window.addEventListener("resize", function () {
  cardFormResize();
});